import { useTranslation } from 'react-i18next';
import { humanizeEnum } from '@/lib/utils';
import { Money, Row, SourceRow, Who, day, type RecordSource } from './bodyParts';

export interface VendorPaymentDetail {
  id: string;
  paymentNumber: string;
  status: string;
  amount: number | string;
  paymentMethod: string;
  reference?: string | null;
  paymentDate: string;
  notes?: string | null;
  rejectionReason?: string | null;
  voidReason?: string | null;
  createdAt: string;
  approvedAt?: string | null;
  voidedAt?: string | null;
  supplierName?: string | null;
  bankAccountName?: string | null;
  createdByName?: string | null;
  approvedByName?: string | null;
  voidedByName?: string | null;
  purchaseOrder?: RecordSource | null;
  journalEntry?: RecordSource | null;
}

/** Read-only vendor payment for the record viewer (POS-I238). */
export function VendorPaymentDetailBody({ data }: { data: VendorPaymentDetail }) {
  const { t } = useTranslation('records');
  return (
    <div className="space-y-5 text-sm">
      <dl className="space-y-1.5">
        <Row label={t('rvDate')}><span dir="ltr">{day(data.paymentDate)}</span></Row>
        {data.supplierName && <Row label={t('rvSupplier')}>{data.supplierName}</Row>}
        <Row label={t('rvAmount')}><Money value={data.amount} /></Row>
        <Row label={t('rvMethod')}>{humanizeEnum(data.paymentMethod)}</Row>
        {data.bankAccountName && <Row label={t('rvBankAccount')}>{data.bankAccountName}</Row>}
        {data.reference && <Row label={t('rvReference')}><bdi dir="ltr">{data.reference}</bdi></Row>}
        {data.notes && <Row label={t('rvNotes')}>{data.notes}</Row>}
      </dl>
      <dl className="space-y-1.5">
        <Who label={t('rvCreatedBy')} name={data.createdByName} at={data.createdAt} />
        <Who label={t('rvApprovedBy')} name={data.approvedByName} at={data.approvedAt} />
        <Who label={t('rvVoidedBy')} name={data.voidedByName} at={data.voidedAt} />
        {data.rejectionReason && <Row label={t('rvRejectionReason')}>{data.rejectionReason}</Row>}
        {data.voidReason && <Row label={t('rvVoidReason')}>{data.voidReason}</Row>}
      </dl>
      <SourceRow
        items={[
          { label: t('rvPurchaseOrder'), source: data.purchaseOrder },
          { label: t('rvJournalEntry'), source: data.journalEntry },
        ]}
      />
    </div>
  );
}
